import { HoldType as ApiHoldType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../common';
import { HoldType } from './types';

export const mapHoldType = (apiHold: ApiHoldType): HoldType => {
  return {
    artist: mapLinkableEntityType(apiHold.artist),
    tour: apiHold.tour ? mapLinkableEntityType(apiHold.tour) : null,
    showDate: apiHold.showDate,
    pencilPosition: apiHold.pencilPosition,
    challenge: apiHold.challenge ?? null,
    confirmationDate: apiHold.confirmationDate ?? null,
    internalComment: apiHold.internalComment,
    tourStatus: apiHold.tourStatus,
    venue: mapLinkableEntityType(apiHold.venue),
    city: apiHold.city,
  };
};
